import styled from 'styled-components';
import {StyledPage} from '../styles';
import container from '@/theme/constants/container';
import colors from '@/theme/constants/colors';
import StyledCtaLink from '@/atoms/Links/CTA/styles';
import pxToRem from '@/theme/helpers/pxToRem';
import typography from '@/theme/typography';
import StyledImgFigure from '@/atoms/Image/styles';
import CtaLink from '@/atoms/Links/CTA/CtaLink';
import breakpoints from '@/theme/constants/breakpoints';

const StyledCollectionPage = styled(StyledPage)``;

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  box-sizing: border-box;
  max-width: ${container.maxWidth};
  width: 100%;
  padding: ${container.padding};
  margin: 0 auto;
`;

export const StyledHero = styled.div`
  width: 100%;
  height: 152px;
  background: ${colors.yellow100};
  position: relative;
  overflow: hidden;

  @media only screen and ${breakpoints.device.m} {
    height: 380px;
  }

  ${StyledCtaLink} {
    position: absolute;
    top: 5px;
    right: 5px;
    background: rgba(0, 0, 0, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.5);
    backdrop-filter: blur(0.3em);
    transition: background 0.1s ease-in;
    box-shadow: 0px 1px 16px 3px rgba(0, 0, 0, 0.4);
    font-size: ${pxToRem(18)};

    &:hover {
      background: rgba(131, 11, 37, 0.3);
      border-color: rgba(255, 255, 255, 0.5);
    }
  }

  ${StyledImgFigure} {
    width: 100%;
    height: 100%;
  }
`;

export const StyledIntro = styled.section`
  max-width: 100%;
  margin: 0 auto;
  padding: ${pxToRem(20)} 0;
  overflow: visible;

  @media only screen and ${breakpoints.device.m} {
    max-width: 50%;
  }

  ${StyledImgFigure} {
    border-radius: 50%;
    margin: -${pxToRem(78)} auto ${pxToRem(20)};
  }

  h1 {
    text-align: center;
  }

  p {
    text-align: center;

    small {
      display: block;
      ${typography.Body3}
    }

    span {
      display: block;
      margin: ${pxToRem(20)} 0;
    }
  }
`;

export const StyledNextCollectionLink = styled(CtaLink)`
  margin: ${pxToRem(50)} auto;
`;

export default StyledCollectionPage;
